export const environment = {
  production: false,
  apiUrl: '/api',
  appName: 'Works with homeXpert (DEV)'
};
